// This folder and index file were auto-generated and included in theme.js by the infinite cli
// Add the various components for your JS inside this folder and import them (or npm modules) like this:
// import someFunction from './someFunction';

export default () => {
  if (document.querySelectorAll('[data-section-type="OccassionDualPods"]').length === 0) {
    return;
  }

  console.log('OccassionDualPods initialized');
};
